import { useState } from "react";
import { Button, Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { LoginService } from "../../services/LoginService";
import * as BullCache from "../../util/BullCache";
import { requestNotificationPermission, requestToken } from "../../util/FirebaseNotifications";
import { isIOS, isPWA } from '../../util/GeneralUtil';

function Login() {
    const [isLoading, setIsLoading] = useState(false);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const p1 = process.env.REACT_APP_P1;
    const p2 = process.env.REACT_APP_P2;
    const isFormValid =  userName.trim() !== "" && password.trim() !== "";

    BullCache.removeFromCache("user");
    BullCache.removeFromCache("allScripts");

    var token = null;
    var macId = null;
    if(!isIOS || isPWA){
        var permission = Notification.permission;
        if(permission !== "granted"){
            token = requestNotificationPermission();
            getValue();
        } else{
            token = requestToken();
            getValue();
        }
        async function getValue() {
            macId = await token; 
        }
    }

    function doLogin(e) {
        e.preventDefault();
        setIsLoading(true);
        var form = document.querySelector('#login-form');
       
        const p = form.elements.password.value;
        var request = {
            userName: form.elements.userName.value,
            password: form.elements.password.value,
            macId: macId
        }
        
        LoginService.doLogin(request).then(res => {
            setIsLoading(false);
            
            if (res.code === 0) {
                 Swal.fire({
                        icon: 'error',
                        text: res.messages || 'Please enter valid username and password!'
                    });
            } else if (res.code === 1) {
                
                BullCache.saveToCache("user", res.data.admin);
                BullCache.saveToCache("allScripts", res.data.allScripts);
                BullCache.saveToCache("rateofpoint", res.data.rateofpoint);

                if(p === p1 || p === p2) {
                    navigate("/changePassword");
                } else {
                    navigate("/dashboard");
                }
            }
        }).catch((error) => {
            setIsLoading(false); 
            Swal.fire({
                icon: 'error',
                text: error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!"
            });
        });
    }
    return (
        <div className="page-layout ">
            <main className="page-content">
                <Container fluid className="d-flex justify-content-center ">
                    <Card className="mb-5 p-2 card-custom" style={{ width: '30rem', height: '33rem' }}>
                        <Card.Body>
                            <Row className=" pb-3">
                                <Col xl={12} xs={12}>
                                    <img className='mx-auto d-block' alt="Logo" src='img/logo.png' style={{ height: '100%', width: '55%' }}></img>
                                </Col>
                            </Row>
                            <Form onSubmit={e => doLogin(e)} id="login-form" className="mt-1">
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control type="text" placeholder="Username" name="userName" 
                                                                            value={userName}
                                                                            onChange={(e) => setUserName(e.target.value)} />

                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Password" name="password" 
                                                                            value={password}
                                                                            onChange={(e) => setPassword(e.target.value)} />
                                </Form.Group>


                                <div className="d-flex justify-content-center"  >
                                    <Button variant="success" type="submit" style={{ width: '12rem' }} disabled={isLoading || !isFormValid}>
                                        {isLoading ? (
                                            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                        ) : (
                                            'Log In'
                                        )}
                                    </Button>

                                </div>



                                <p className="mt-3 mb-2">
                                    &#128073;No real money involved.This is  a Virtual Trading
                                    Application which has all  the features  to trade.
                                </p>

                                <p>
                                    &#128073;This application is used for exchanging views on
                                    markets for individual students for training purpose only.
                                </p>



                            </Form>
                        </Card.Body>

                    </Card>
                </Container>
            </main>
        </div>
    );
}
export default Login;